const WA = "https://wa.me/917995495312?text=Hi%20Aria%20—%20I%20want%20to%20answer%20your%20three%20questions";

const QUESTIONS = [
  {
    icon: "💡",
    n: "01",
    q: "What's your biggest bottleneck right now?",
    hint: "The thing slowing everything else down.",
  },
  {
    icon: "⏰",
    n: "02",
    q: "What's taking the most time from your team every single week?",
    hint: "The work that's beneath their pay-grade.",
  },
  {
    icon: "🤖",
    n: "03",
    q: "If you could automate one thing in your business right now — what would it be, and why?",
    hint: "Be honest. Don't say \"everything\".",
  },
];

const Questions = () => (
  <section
    className="questions-section"
    id="questions"
    data-bg="cream"
    data-testid="questions-section"
  >
    <div className="questions-glow questions-glow-a" />
    <div className="questions-glow questions-glow-b" />
    <div className="questions-grain" />

    <div className="questions-inner">
      <div className="questions-head reveal">
        <span className="eyebrow">The million-dollar questions</span>
        <h2 className="questions-h2">
          We don't sell <span className="serif">AI tools</span>.<br />
          We solve <span className="serif">businesses</span>.
        </h2>
        <p className="questions-sub">
          Before we build anything, Aria asks the questions no consultant
          ever asked you.
        </p>
      </div>

      <div className="questions-grid">
        {QUESTIONS.map((q, i) => (
          <article
            key={i}
            className="question-card reveal"
            style={{ transitionDelay: `${i * 0.08}s` }}
            data-testid={`question-card-${i}`}
          >
            <div className="question-top">
              <span className="question-icon">{q.icon}</span>
              <span className="question-num">{q.n}</span>
            </div>
            <p className="question-text">"{q.q}"</p>
            <p className="question-hint">{q.hint}</p>
          </article>
        ))}
      </div>

      <div className="questions-foot reveal">
        <p className="questions-foot-line">
          Three answers. One conversation. A complete picture of your business.
        </p>
        <a
          href={WA}
          target="_blank"
          rel="noreferrer"
          className="btn btn-gold"
          data-testid="questions-cta"
        >
          Ask Aria these questions →
        </a>
      </div>
    </div>
  </section>
);

export default Questions;
